import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

/**
 * CircularStaticProgress component for rendering a circular progress bar with a static value.
 *
 * @component
 * @param {Object} props - The properties of the component.
 * @param {number} props.value - The value of the progress (percentage).
 * @param {string} props.color - The color of the progress bar.
 * @param {number|string} props.width - The width of the container.
 * @param {number|string} props.height - The height of the container.
 * @param {number|string} props.size - The size of the circular progress bar.
 * @param {number} props.thickness - The thickness of the circular progress bar.
 * @param {string} props.metricName - The name of the metric associated with the progress bar.
 * @returns {JSX.Element} The CircularStaticProgress component.
 */
const CircularStaticProgress = ({value, color, width, height, size, thickness, metricName}) => {
  return (
    <div
      style={{
        position: 'relative',
        width: width,
        height: height,
        background: '#fff', // Add a contrasting background color
      }}
    >
      <CircularProgress
        variant="determinate"
        value={metricName === 'Overall Health Score' ? Number(Math.round(value).toFixed(0)) : 100}
        size={size}
        thickness={thickness}
        sx={{
          '& .MuiCircularProgress-circle': {
            color: color,
          },
        }}
      />
      <Typography
        variant="h6"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        sx={{fontWeight: 'bold'}}
      >
        {Math.round(value).toFixed(0)}
      </Typography>
    </div>
  );
};

export default CircularStaticProgress;
